module.exports = __webpack_public_path__ + "static/media/transfer_ownership.e7ebedaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/transfer_ownership.svg
// module id = 1059
// module chunks = 0